/**
 * Persisted dismissal for the start-page import-discovery card — a single
 * app-wide flag backed by localStorage via zustand's `persist` middleware
 * (same convention as `columnsCoachmarkStore.ts`). Dismissing is permanent:
 * the card is a one-time offer, and the Import… menus stay reachable from
 * Manage Connections, the New Connection dialog, and the command palette.
 */
import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { createGuardedJsonStorage } from '../../../core/storage/guardedJsonStorage';

type ImportDiscoveryState = {
  dismissed: boolean;
  dismiss: () => void;
  /** Test/debug escape hatch — brings the card back. */
  reopen: () => void;
};

export const useImportDiscoveryStore = create<ImportDiscoveryState>()(
  persist(
    (set) => ({
      dismissed: false,
      dismiss: () => set({ dismissed: true }),
      reopen: () => set({ dismissed: false }),
    }),
    {
      name: 'jam-sql-import-discovery-card',
      // Crash-proof write (core/storage/guardedJsonStorage.ts): a full origin must not throw out of
      // set(). No toast here — this is a one-bit dismissal flag; the drop is still reported to
      // telemetry and the console.
      storage: createGuardedJsonStorage(),
      version: 1,
    }
  )
);
